import { createSvgComponent } from "../../icon/createSvgComponent";
import Cs from "@core/__generated__/icon/figma/cs.svg";
export default createSvgComponent(Cs);